module.exports = __webpack_public_path__ + "b11a8b98c1afbb161ea39cbead9e9dad.png";